import { useState, useCallback } from "react";

export interface SortConfig {
  key: string;
  direction: "asc" | "desc";
}

export function useSortable(defaultKey = "date", defaultDirection: "asc" | "desc" = "desc") {
  const [sortConfig, setSortConfig] = useState<SortConfig>({ key: defaultKey, direction: defaultDirection });

  const requestSort = useCallback((key: string) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "desc" ? "asc" : "desc",
    }));
  }, []);

  return { sortConfig, requestSort };
}
